"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_SETTINGS = void 0;
const helpers_1 = require("../../client/helpers");
const settings_fragments_1 = require("./settings.fragments");
exports.UPDATE_SETTINGS = `
  mutation UpdateSettings(
    $currency: String!
    $defaultPricing: [SettingsDefaultPricingInput!]
    $defaultChannelId: ID
    $extendOptions: JSON
    $selectedEmbedLogo: String
    $embedLogos: [String!]
  ) {
    settings {
      update(
        input: {
          defaultChannelId: $defaultChannelId
          currency: $currency
          defaultPricing: $defaultPricing
          extendOptions: $extendOptions
          embedLogos: { default: $embedLogos, selected: $selectedEmbedLogo }
        }
      ) {
        entity {
          ...SettingsFragment
        }
      }
    }
  }
  ${settings_fragments_1.SETTINGS_FRAGMENT}
`;
//# sourceMappingURL=settings.mutations.js.map